import React, { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/reset-password`, { token, password }, { withCredentials: true });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Reset failed');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="py-20 px-6 text-center">
        <p className="text-sm text-[#6B6B6B]">Invalid reset link.</p>
        <Link to="/forgot-password" className="text-sm text-[#1A1A1A] underline mt-2 inline-block">Request a new one</Link>
      </div>
    );
  }

  return (
    <div data-testid="page-reset-password">
      <section className="py-20 px-6">
        <div className="max-w-sm mx-auto">
          <div className="text-center mb-8">
            <p className="font-serif text-xl text-[#1A1A1A] mb-2">Set New Password</p>
          </div>

          {success ? (
            <div className="text-center py-6" data-testid="reset-success">
              <p className="text-sm text-[#6B6B6B]">Password updated. Redirecting to login...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-form">
              {error && <div className="p-3 bg-red-50 border border-red-200 rounded text-sm text-red-700">{error}</div>}
              <div>
                <label className="text-xs uppercase tracking-[0.15em] text-[#999] block mb-1">New Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={8}
                  className="w-full border border-[#E8E4DC] rounded px-4 py-2.5 text-sm bg-white focus:outline-none focus:border-[#1A1A1A]" data-testid="reset-password" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.15em] text-[#999] block mb-1">Confirm Password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8}
                  className="w-full border border-[#E8E4DC] rounded px-4 py-2.5 text-sm bg-white focus:outline-none focus:border-[#1A1A1A]" data-testid="reset-confirm" />
              </div>
              <button type="submit" disabled={loading} className="w-full py-3 bg-[#1A1A1A] text-white text-sm rounded hover:bg-[#333] transition-colors disabled:opacity-50" data-testid="reset-submit">
                {loading ? 'Updating...' : 'Update Password'}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
